import Swiper from 'swiper/bundle';
import { updateSlidesInert } from '../utils/accessibility-swiper';

const getSwiperA11yMessages = () => {
	const locale = window.Shopify?.locale || document.documentElement.lang || 'uk';
	const isUk = locale === 'uk';

	return {
		enabled: true,
		slideLabelMessage: '',
		paginationBulletMessage: isUk ? 'Перейти до слайду {{index}}' : 'Перейти к слайду {{index}}',
		nextSlideMessage: isUk ? 'Наступний слайд' : 'Следующий слайд',
		prevSlideMessage: isUk ? 'Попередній слайд' : 'Предыдущий слайд',
	};
};

const syncSlidesInert = (swiper) => {
	window.requestAnimationFrame(() => {
		updateSlidesInert(swiper, 'visible');
	});
};

export function packageSlider() {
	let sliderEl = document.querySelector('.package .swiper');
	
	if (sliderEl) {
		let slider = new Swiper(sliderEl, {
			// loop: true,
			speed: 500,
			watchSlidesProgress: true,
			// slidesPerView: 1,
			// direction: 'vertical',
			// effect: 'fade',
			// fadeEffect: {
			// 	crossFade: true
			// },
			
			pagination: {
				el: ".package .slider-pagination",
				bulletClass: 'slider-pagination__bullet',
				bulletActiveClass: 'slider-pagination__bullet--active',
				clickable: true
			},
			navigation: {
				prevEl: ".package .slider-controls__btn--prev",
				nextEl: ".package .slider-controls__btn--next",
			},
			a11y: getSwiperA11yMessages(),
			on: {
				init(swiper) {
					syncSlidesInert(swiper);
				},
				slideChange(swiper) {
					syncSlidesInert(swiper);
				},
				transitionEnd(swiper) {
					syncSlidesInert(swiper);
				},
				resize(swiper) {
					syncSlidesInert(swiper);
				},
				breakpoint(swiper) {
					syncSlidesInert(swiper);
				},
			},
			
			breakpoints: {
				100: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				// 350: {
				// 	slidesPerView: 1.25,
				// 	spaceBetween: 16
				// },
				650: {
					slidesPerView: 2,
					spaceBetween: 16
				},
				900: {
					slidesPerView: 3,
					spaceBetween: 24
				},
				
				1024: {
					slidesPerView: 4,
					spaceBetween: 24
				},
				
			},
		});
	}
}
